// A0 Level Aggregator - Absolute Beginner
// Tüm A0 ünite içeriklerini birleştirir

import { A0_UNIT_1 } from './kariyerContentsA0Unit1';
import { A0_UNIT_2 } from './kariyerContentsA0Unit2';
import { A0_UNIT_3 } from './kariyerContentsA0Unit3';
import { A0_UNIT_4 } from './kariyerContentsA0Unit4';
import { A0_UNIT_5 } from './kariyerContentsA0Unit5';
import { A0_FINAL } from './kariyerContentsA0Final';

export const A0_LEVEL = {
  ...A0_UNIT_1,  // Alfabe, Sesler & Havacılık Alfabesi
  ...A0_UNIT_2,  // Sayılar & Uçuş Bilgileri
  ...A0_UNIT_3,  // BE Fiili (am/is/are)
  ...A0_UNIT_4,  // Articles (a/an/the)
  ...A0_UNIT_5,  // Zamirler & Possessives
  ...A0_FINAL,   // Final Sınavı
};

export default A0_LEVEL;
